/**
 * Created by Shaun on 03/06/2016.
 */
import io from 'socket.io-client';

import Vuex from 'vuex';

class Socket {
  constructor() {
    this.loadSocket = IS_LIVE === false && IS_TEST === false;

    if (this.loadSocket === true) {
      this.socket = io();
    } else {
      this.socket = {};
    }

    this.actionsToRegister = [];

    this.$store = null;
    this.getters = null;


    if (this.loadSocket === true) {
      //register events
      this.socket.on('connect', this.onConnected.bind(this));
      this.socket.on('disconnect', this.onDisconnect.bind(this));
      this.socket.on('dispatchAction', this.onActionDispatch.bind(this));
      this.socket.on('dispatchActionToAllModulesWithAction', this.dispatchActionToAllModulesWithAction.bind(this));
    }
  }

  validate(idToken) {
    if (this.loadSocket === true && this.socket.connected === true) {
      this.socket.emit('validate', {idToken});
    }
  }

  setStore(store) {
    if (store instanceof Vuex.Store) {
      this.$store = store;
    }
  }

  setGetters(getters) {
    this.getters = getters;
  }

  addAction(moduleName, action) {
    let actionToRegister = {moduleName, action};

    this.actionsToRegister.push(actionToRegister);

    //register the action
    if (this.socket.connected === true) {
      this.socket.emit('registerAction', actionToRegister);
    }
  }

  sendAction(action, payload) {
    if (this.socket.connected === true) {
      this.socket.emit('action', {
        action: action,
        payload: payload
      });
    }
  }

  onConnected() {
    console.log('Connected');

    if (this.$store.state.user.loggedInUser.state.state === 'SIGNED_IN') {
      this.validate(this.$store.getters['user/idToken']());
    }

    this.actionsToRegister.forEach((action) => this.socket.emit('registerAction', action));
  }

  onActionDispatch(dispatchObject) {
    this.$store.dispatch(dispatchObject.action, dispatchObject.payload || null);
  }

  dispatchActionToAllModulesWithAction(dispatchObject) {
    _.forEach(this.actionsToRegister, (actionObj) => {
      if (actionObj.action === dispatchObject.action) {
        this.$store.dispatch(`${actionObj.moduleName}/${actionObj.action}`, dispatchObject.payload || null);
      }
    });
  }

  onDisconnect() {
    console.log('Disconnected');
  }
}

export default new Socket();
